function actionInputChange(elem) {
    $(elem).on("input change", function () {
        var end_field = $(this).attr("data-ref-field");
        if($(this).attr('type') === 'checkbox'){
          $(end_field).prop('checked',$(this).is(':checked'));
        }
        var val = $(this).val();
        $(end_field).val(val);
    });
}

function loadInputFields(elem) {
  $(elem).each(function () {
      var end_field = $(this).attr("data-ref-field");
      if ($(this).val()) {
        console.log('here');
        if($(this).attr('type') === 'checkbox'){
          $(end_field).prop('checked',$(this).is(':checked'));
        }
        var field_data = $(this).val()
        console.log(field_data);
        console.log(end_field);
        $(end_field).val(field_data);
    }
  });
}

function clearInputFields(elem){
  $(elem).each(function () {
    if($(this).attr('type') === 'checkbox'){
      $(this).prop('checked',false);
    }else{
      $(this).val('');
    }
    $("#submitBtn").attr("disabled", "disabled");
  });
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function openLoader(){  
  let loader = document.getElementById("form-loader");
  console.log('ici !!!');

  loader.classList.add("loader-open");
  $('.custom-spinner').css('display','block');

  $('body').css('overflow', 'hidden');
  $('.loader-open').css('webkitBackdropFilter', 'blur(4px)');
}

function closeLoader(){
  let loader = document.getElementById("form-loader");

  $('.loader-open').css('webkitBackdropFilter', 'blur(4px)');
  loader.classList.remove("loader-open");
  $('.custom-spinner').css('display','none');

  $('body').css('overflow', 'auto');
}

document.addEventListener("DOMContentLoaded", function () {
  const addressInput = document.getElementById('id_address_2');
  const cityInput = document.getElementById('id_city_2');
  const zipInput = document.getElementById('id_cp');
  const countryInput = document.getElementById('id_country_2');

  const submitButton = document.getElementById('submitBtn');
  
  const suggestionsDiv = document.getElementById('suggestions');
  
   console.log('competition');
  var date = document.getElementById('end-date').value;
  var hour = document.getElementById('end-hour').value;
  var today = new Date();

  var message_end = document.getElementById('form_end');
  var form_section = document.getElementById('competition-section');

  actionInputChange($(".input-filer-function"));
  clearInputFields($(".input-filer-function"));
  // sleep(1000).then(() => {loadInputFields($(".input-filer-function"));});

  function createCustomDate(dateStr, timeStr) {
    const [day, month, year] = dateStr.split('/').map(Number);
    
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    
    const customDate = new Date(2000 + year, month - 1, day, hours, minutes, seconds);
    
    return customDate;
  }

  if(date != ""){
    var new_date = createCustomDate(date,hour);
    console.log(new_date);
    console.log(today);

    if(today <= new_date){
      
      form_section.style.display = "block";
      message_end.style.display = "none";
    }else{
      form_section.style.display = "none";
      message_end.style.display = "flex";
    }
  }

    // Fonction pour obtenir des suggestions d'adresses depuis l'API Photon
  async function fetchAddressSuggestions(query) {
      const response = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(query)}`);
      const data = await response.json();
      return data.features.map(feature => ({
          housenumber: (feature.properties.housenumber) ? feature.properties.housenumber: '',
          address: (feature.properties.street) ? feature.properties.street : feature.properties.name,
          city: (feature.properties.district) ? feature.properties.district : feature.properties.city,
          country: feature.properties.country,
          zip: feature.properties.postcode
        }));
  }

  // Écouteur pour la saisie d'adresse
  addressInput.addEventListener('input', async function() {
      const query = addressInput.value;
      suggestionsDiv.innerHTML = '';

      // Si la saisie est vide, masquer les suggestions
      if (!query) {
          suggestionsDiv.innerHTML = '';
          return;
      }

      // Récupérer les suggestions d'adresses
      const suggestions = await fetchAddressSuggestions(query);

      // Afficher les suggestions
      suggestions.forEach(suggestion => {
        if(suggestion.country != "Luxembourg" && suggestion.country != "France" && suggestion.country != "Belgique" && suggestion.country != "Allemagne" && suggestion.country != "Suisse"){return;}
          const suggestionItem = document.createElement('div');
          suggestionItem.textContent = `${suggestion.housenumber} ${suggestion.address}, ${suggestion.zip} ${suggestion.city}, ${suggestion.country}`;
          suggestionItem.style.padding = '8px';
          suggestionItem.style.cursor = 'pointer';

          // Quand l'utilisateur clique sur une suggestion, remplir le champ de saisie
          suggestionItem.addEventListener('click', function() {
              addressInput.value = suggestion.housenumber+' '+suggestion.address;
              cityInput.value = suggestion.city;
              zipInput.value = suggestion.zip;
              countryInput.value = suggestion.country;

              $('#id_street').val(suggestion.housenumber+' '+suggestion.address);
              $('#id_location').val(suggestion.city);
              $('#id_zipcode').val(suggestion.zip);
              $('#id_country').val(suggestion.country);
              suggestionsDiv.innerHTML = ''; // Masquer les suggestions
          });

          suggestionsDiv.appendChild(suggestionItem);
      });
  });

  $('.form_competition').submit(function (e){
    openLoader();
    e.preventDefault();
    var action = $('#concours-form').attr('action');
    var goodAction = '';
    if(!action.startsWith('http')){
      goodAction = 'https://pro.lineheart.lu'+action;
    }else{
      goodAction = action;
    }
    $('#concours-form').attr('action',goodAction);

    var data = $('#concours-form').serializeArray();
  
      $.ajax({
        // create an AJAX call...
        data: data, // get the form data
        type: "POST", // GET or POST
        url: goodAction,
        success: function (response) {
          closeLoader();
          var error = response.search('danger');
          if(error != -1){
            $('#error').html(response);
          }else{
            $('#send_resp').html(response);
            $('.form_competition').css('display','none');
          }
        
        },
      });
  });

  $("#check_cgv").click(function () {
    console.log('ici');
    if ($(this).is(":checked")) {
      $("#submitBtn").removeAttr("disabled");
    } else {
      $("#submitBtn").attr("disabled", "disabled");
    }
  });
});